module.exports = __webpack_public_path__ + "static/media/bm-dmp+orto.a1d2a914.png";